const CartActionTypes = {
    TOGGLE_CART_HIDDEN: 'TOGGLE_CART_HIDDEN',
    ADD_ITEM: 'ADD_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM',
    CLEAR_ITEM: 'CLEAR_ITEM',
    CLEAR_CART: 'CLEAR_CART',
    SET_CART_FROM_FIREBASE: 'SET_CART_FROM_FIREBASE',
    UPDATE_CART_IN_FIREBASE: 'UPDATE_CART_IN_FIREBASE',
    CHECKOUT_SUCCESS: 'CHECKOUT_SUCCESS',
    BUY_AGAIN: 'BUY_AGAIN',
};

export default CartActionTypes;
